import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminCuratedInsights = lazy(() => import("@/pages/admin/AdminCuratedInsights"));

export const Route = createFileRoute("/admin/curated-insights")({
  component: AdminCuratedInsights,
});
